import { AxiosError, AxiosResponse } from "axios";

export interface SimulationControl {
  /* eslint-disable @typescript-eslint/no-explicit-any*/
  postModelForSimulation(jsonModel: string): Promise<string>;
  load(id: string, err?: (err: any) => void): Promise<AxiosError | null | AxiosResponse>;
  setup(setupCallback?: () => void): void;
  enter(enterCallback?: (_ctx: SimulationContext) => void): void;
  exit(exitCallback?: () => void): Promise<void>;
  tearDown(): void;

  // actions
  /* eslint-disable @typescript-eslint/no-explicit-any*/
  raiseEvent(fqName: string, value?: any): void;
  changeValue(fqName: string, newValue: any): void;
  /* eslint-enable @typescript-eslint/no-explicit-any*/

  // reactions
  addOnStateEntered(callback: (data: { stateId: string; stateName: string }) => void): SimulationControl;
  addOnStateExited(callback: (data: { stateId: string; stateName: string }) => void): SimulationControl;
  addOnReactionFired(callback: (stateId: string, transId: string) => void): SimulationControl;
  addOnValueChanged(
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: (varId: string, value: any, varIdProp?: string) => void
  ): SimulationControl;
  getModel(): string;
  getContext(): SimulationContext;
  getIsRunning(): boolean;
}

export class Slot {
  kind: string;
  type: string;
  name: string;
  fqName: string;
  featureId: string;
  writable: boolean;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  elements?: Array<Slot>;
}

export function isNumber(slot: Slot): boolean {
  return slot.type === "integer" || slot.type === "real";
}

export class SimulationContext extends Slot {
  findBy(propName: string, id: string) {
    return this.doFind(id, propName, this);
  }

  findByFqn(fqName: string): Slot {
    return this.doFind(fqName, "fqName", this);
  }

  findByFeatureId(featureId: string): Slot {
    return this.doFind(featureId, "featureId", this);
  }

  doFind(id: string, propName: string, slot: Slot): Slot {
    if (slot[propName] === id) return slot;

    if (slot.elements) {
      for (const e of slot.elements) {
        const result = this.doFind(id, propName, e);
        if (result) return result;
      }
    }
    return undefined;
  }
}
